import React from 'react';

const LanguagePills = ({ activeLang, availableLang, onChangeLang }) => {
    const langLabels = {
        en: '🇬🇧 EN',
        hi: '🇮🇳 HI',
        ar: '🇸🇦 AR',
        cs: '🇨🇿 CZ'
    };

    return (
        <div className="pfc-lang-pills">
            {availableLang.map(lang => (
                <button
                    key={lang}
                    type="button"
                    className={`pfc-lang-pill ${activeLang === lang ? 'active' : ''}`}
                    onClick={() => onChangeLang(lang)}
                    aria-pressed={activeLang === lang}
                >
                    {langLabels[lang] || lang.toUpperCase()}
                </button>
            ))}
        </div>
    );
};

export default LanguagePills;
